<template>
  <ValidationObserver ref="form" #default="{ dirty, valid }">

    <main class="content">
      <div class="content__heading content__heading--navigation">
        <h1>
          <i class="icon--tags"></i> {{ $t('fusebox.label') }}: {{ niceTitle }}
          <small v-if="fuseboxList !== 'undefined'"> ({{ $store.getters['label/fuseboxTotal'] }})</small>
        </h1>
      </div>

      <ul class="breadcrumbs">
        <li class="breadcrumbs__crumb breadcrumbs__crumb--first">
          <router-link :to="{ name: 'label.index'}" :data-value="$t('general.labels')">
          </router-link>
        </li>
        <li class="breadcrumbs__crumb breadcrumbs__crumb--last">
          <span :data-value="niceTitle"></span>
        </li>
      </ul>

      <section class="content--boxed">
        <input :placeholder="$t('search.fuseboxes')" type="text" name="search" v-model="search" :required="false"
               class="input input--search"/>

        <div class="table table--badged" v-if="fuseboxList.length > 0">

          <div class="table--badged__row table--badged__row--clickable" v-for="fusebox in fuseboxList"
               :key="fusebox.uuid" @click=show(fusebox.uuid)>

            <div class="table--badged__badge table--badged__badge--light"
                 :class="{'table--badged__badge--shared': (fusebox.shared && $can('request_access', 'plans'))}">
              <i class="icon--list"></i>
            </div>

            <div class="table--badged__description">
              <h3>
                {{ fusebox.name }} <small v-if="fusebox.location.name">
                ({{ fusebox.location.name }})</small>
              </h3>
              <small>
                <span class="table--badged__description__item" v-if="fusebox.location.updated_at !== 'undefined'"><i
                  class="icon--calendar"></i> {{ fusebox.updated_at | moment('MMM D YYYY, HH:mm') }}</span>
                <span class="table--badged__description__item" v-if="fusebox.location.address !== 'undefined'"><i
                  class="icon--location"></i> {{ [fusebox.location.no, fusebox.location.address].join(' ') }}</span>
              </small>
            </div>
            <div class="navigation--buttonGroup navigation--buttonGroup--table">
              <button v-if="$can('request_access', 'plans') && fusebox.shared"
                      @click.stop="$modal.show('revoke-confirmation', { fusebox:  fusebox.uuid})"><i
                class="icon--key"></i>
              </button>
              <button @click.stop="downloadPdf(fusebox)"><i class="icon--pdf"></i></button>
              <!--              <button @click.stop="prepEdit(fusebox)"><i class="icon&#45;&#45;edit"></i></button>
                            <button v-if="(fusebox.shared && isRole(roles.OWNER.ROLE_OWNER) || !fusebox.shared)"
                                    @click.stop="$modal.show('confirmation', { id:  fusebox.uuid})"><i class="icon&#45;&#45;delete"></i>
                            </button>-->
            </div>

          </div>

        </div>
        <template v-if="total === 0">
          <div class="message" v-if="!isFilterApplied">
            {{ $t('messages.noFuseboxes') }}
          </div>
          <div class="message" v-else>
            {{ $t('messages.noResults') }}
          </div>
        </template>
      </section>

      <DqPaginate v-if="lastPage > 1" v-model="page" :page-count="lastPage"
                  :click-handler="dispatchList"/>
    </main>
  </ValidationObserver>
</template>

<script>
import { errHandler } from '@/helpers'
import DqPaginate from '@/components/Parts/DqPaginate'
import { mapGetters } from 'vuex'
import _debounce from 'lodash.debounce'

export default {
  name: 'Location-City-Index',
  components: {
    DqPaginate
  },
  beforeMount () {
    this.$store.commit('loader/startIntLoading')
  },
  async mounted () {
    this.init(true)
    await this.$store.dispatch('label/resetFuseboxFilters')
    this.init(true)
    this.debouncedSearch = _debounce(async () => {
      await this.$store.dispatch('label/resetFuseboxPage', { resetPage: true })
      this.dispatchList()
    }, 200)
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters('label', {
      fuseboxList: 'fuseboxList',
      lastPage: 'fuseboxLastPage',
      total: 'fuseboxTotal',
      isFilterApplied: 'isFilterAppliedFb'
    }),
    page: {
      get () {
        return this.$store.getters['label/fuseboxCurrentPage']
      },
      set (value) {
        this.$store.commit('label/setFuseboxPage', value)
      }
    },
    search: {
      get () {
        return this.$store.getters['label/searchFb']
      },
      set (value) {
        this.$store.commit('label/setSearchFb', value)
      }
    },
    niceTitle () {
      return this.$route.params.slug.split('-').join(' ')
    }
  },
  methods: {
    async init (resetPage = false) {
      try {
        await this.$store.dispatch('label/resetFuseboxPage', { resetPage })
        this.dispatchList()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async dispatchList () {
      try {
        await this.$store.dispatch('label/getFusebox', {
          slug: this.$route.params.slug
        })
        this.$store.dispatch('loader/stopIntLoading')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    show (id) {
      this.$router.push({ name: 'fusebox.single.index', params: { id: id } })
    },
    async downloadPdf (fusebox) {
      try {
        const data = await this.$store.dispatch('fusebox/pdfGenerate', fusebox.qr_code)
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${fusebox.name}.pdf`)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    }
  },
  watch: {
    search () {
      this.debouncedSearch()
    }
  },
  beforeDestroy () {
    this.$store.commit('location/clearItems')
  }
}
</script>
